// Keys that bleed into the form values from the trip redux slice (loader meta) and the
// AddOns section (which saves itself directly). They should never reach the trip update payload.
const TRIP_PAYLOAD_OMIT_KEYS = new Set([
  "loading",
  "loaded",
  "firstLoaded",
  "failed",
  "requested_at"
])

export const stripTripPayloadKeys = (values) =>
  Object.fromEntries(Object.entries(values || {}).filter(([k]) => !TRIP_PAYLOAD_OMIT_KEYS.has(k)))
